const Locale = {
  EN: 'en',
  KY: 'ky',
  RU: 'ru',
  TR: 'tr',
};

const Locales = {
  DEFAULT_LOCALE: Locale.RU,
  Locale,
  SUPPORTED_LOCALES: [Locale.EN, Locale.KY, Locale.RU],
};

module.exports = Locales;
